import React from "react";
import { UserProvider } from "../../contexts/UserContext";

import { TableBody } from "../../UI/TableBody";

import { UserInviteSearchResultsTableBodyRow } from "./UserInviteSearchResultsTableBodyRow";

interface IProps {
  users: Record<string, any>[];
  isGlobalSearch: boolean;
}

export const UserInviteSearchResultsTableBody: React.FC<IProps> = (props) => (
  <TableBody>
    {props.users.map((user) => (
      <UserProvider userId={user.id} key={user.id}>
        <UserInviteSearchResultsTableBodyRow user={user} isGlobalSearch={props.isGlobalSearch} />
      </UserProvider>
    ))}
  </TableBody>
);
